var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAboutStroke7 = function SvgAboutStroke7(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 293,
    height: 497,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#205287",
    strokeDasharray: "22 22",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M1.5 6.119c23.91 0 84.296 4.103 108.139 1.415 10.24-1.155 20.297-4.036 30.5-5.256 23.986-2.869 56.811 3.84 80.923 3.84 15.42 0 33.082-4.64 42.921 14.151 6.051 11.559 2.64 12.061 7.932 24.46 7.777 18.224 14.106 37.706 16.903 58.625 6.081 45.474.147 89.706-2.645 134.835-.653 10.542-1.205 20.771-1.323 31.334-.138 12.271-3.29 23.703-3.895 35.781-1.057 21.074-.587 42.328-2.058 63.375-1.681 24.038 12.55 65.079 0 82.702-17.927 25.173-45.87 32.699-69.746 41.34-17.798 6.441-123.622-5.105-141.651 0"
  })));
};
export default SvgAboutStroke7;